type DateFilterOption = {
  label: string;
  value: number;
  isOrgDim2Filter?: boolean;
};

export const enum SpecialDateFilterValue {
  ALL_TIME = 0,
  CUSTOM_DATE = 1,
}

export const DateFilterOptions: DateFilterOption[] = [
  { label: 'ALL_TIME', value: SpecialDateFilterValue.ALL_TIME },
  { label: '12', value: 12 },
  { label: '6', value: 6 },
  { label: '3', value: 3 },

  // Org dimension filter based on quarter
  { label: '8', value: 24, isOrgDim2Filter: true },
  { label: '4', value: 12, isOrgDim2Filter: true },
  { label: '2', value: 6, isOrgDim2Filter: true },

  { label: 'CUSTOM_DATE', value: SpecialDateFilterValue.CUSTOM_DATE },
];
